// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://seohd2mf5vbm5ooyudd5hmwism.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-sfugumm7rjeozbxy7ypde5gqua",
    "aws_content_delivery_bucket": "comebackcp.wf-datahub.com-test",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d24yn4tldfd74i.cloudfront.net"
};


export default awsmobile;
